<template>
  <v-container id="user-list">
    <v-row>
      <v-col>Usuários do Sistema</v-col>
      <v-col class="text-right">
        <v-btn
          outlined
          color="primary"
          class="ml-3"
          :to="'/inscricao/auth/usuarios/novo'"
        >
          Novo Usuário
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-text-field
          v-model="search"
          filled
          append-icon="mdi-magnify"
          label="Pesquise..."
          clearable
        ></v-text-field>
      </v-col>

      <v-col lg="2" md="2" sm="12">
        <v-btn outlined color="primary" class="ml-3" @click="listUsers()">
          <span>Filtrar</span>
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="usuarios"
          class="elevation-1"
          hide-default-footer
          disable-pagination
          mobile-breakpoint="0"
          :search="search"
          :custom-filter="filterItems"
        >
          <template v-slot:item.nome="{ item }">
            <a :href="'./#/inscricao/auth/usuarios/editar/' + item.id">{{
              item.nome
            }}</a>
          </template>

          <template slot="no-data">
            <span> Nenhum usuário retornado </span>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { usuarioAPI } from "@/apis";

export default {
  components: {},
  computed: {
    ...mapGetters(["user", "isAnalista", "isFullAdmin"]),
  },
  data() {
    return {
      headers: [
        { text: "Nome", value: "nome" },
        { text: "E-mail", value: "email" },
      ],
      usuarios: [],
      search: "",
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    filterItems(val, search) {
      var s = search.toString().toLowerCase();

      var result =
        val != null &&
        typeof val !== "boolean" &&
        val.toString().toLowerCase().indexOf(s) > -1;

      return result;
    },
    listUsers() {
      this.setLoading(true);

      usuarioAPI
        .get()
        .then((resp) => {
          this.usuarios = resp.data;
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter usuários");
        });
    },
  },
  async mounted() {
    this.listUsers();
  },
};
</script>
